import { IFRAME_KEYS } from "../../pages/LandingPage/constants";
import { PaymentsLaunchContext } from "../../types";

export const getPaymentsLaunchContext = ():
  | PaymentsLaunchContext
  | undefined => {
  const params = new URLSearchParams(window.location.search);

  const enterpriseId = params.get(IFRAME_KEYS.PARAMS.ENTERPRISE_ID)?.trim();

  const storeId = params.get(IFRAME_KEYS.PARAMS.STORE_ID)?.trim();

  if (!enterpriseId || !storeId) {
    return undefined;
  }

  return {
    enterpriseId,
    storeId,
  };
};
